import moment from 'moment'

/**
 * @description: 订单状态
 */
 export const OrderStatusCode = {
  TO_BE_SUBMITTED: {
    val: '0',
  }, // 待提交，货主端文案用待提交
  // 后端说货主不会有1的状态
  TO_BE_DISPATCH: {
    val: '2',
  }, // 待派车
  TO_BE_START: {
    val: '3'
  }, // 待提货
  TO_BE_SIGN: {
    val: '4',
  }, // 运输中-代签收
  PART_SIGN: {
    val: '5',
  }, // 运输中-部分签收
  IN_TRANSIT: {
    val: '4,5',
  }, // 运输中
  BALANCE_CHECK: {
    val: '6',
  }, // 已签收
  CANCEL: {
    val: '9',
    defalutNotShow: true,
  }, // 已取消
  ABNORMAL: {
    val: '100',
  }, // 异常
}

export const OrderStatus = {
  [OrderStatusCode.TO_BE_SUBMITTED.val]: '待接单', // 待提交，货主端文案也用待提交
  [OrderStatusCode.TO_BE_DISPATCH.val]: '待派车', // 待派车
  [OrderStatusCode.TO_BE_START.val]: '待提货', // 待提货
  [OrderStatusCode.TO_BE_SIGN.val]: '运输中', // 运输中-代签收
  [OrderStatusCode.PART_SIGN.val]: '运输中', // 运输中-部分签收
  [OrderStatusCode.IN_TRANSIT.val]: '运输中', // 运输中
  [OrderStatusCode.BALANCE_CHECK.val]: '已签收', // 已签收
  [OrderStatusCode.CANCEL.val]: '已取消', // 已取消
  [OrderStatusCode.ABNORMAL.val]: '异常', // 异常
}

// 订单进度tab
export const OrderProgressTab = {
  ALL: 'ALL',
  DOING: 'DOING',
  FINISH: 'FINISH',
  CANCEL: 'CANCEL'
}
export const OrderProgressTabMap = [
  { key: OrderProgressTab.ALL, title: '全部'},
  { key: OrderProgressTab.DOING, title: '进行中'},
  { key: OrderProgressTab.FINISH, title: '已完成'},
  { key: OrderProgressTab.CANCEL, title: '已取消'}
];
// 订单进度状态
export const OrderProgressStatus = {
  [OrderProgressTab.ALL]: [
    OrderStatusCode.TO_BE_SUBMITTED, // 待提交
    OrderStatusCode.TO_BE_DISPATCH, // 待派车
    OrderStatusCode.TO_BE_START, // 待提货
    // OrderStatusCode.TO_BE_SIGN, // 运输中-代签收
    // OrderStatusCode.PART_SIGN, // 运输中-部分签收
    OrderStatusCode.IN_TRANSIT,
    OrderStatusCode.BALANCE_CHECK, // 已签收
    OrderStatusCode.CANCEL,
    OrderStatusCode.ABNORMAL,
  ],
  [OrderProgressTab.DOING]: [
    OrderStatusCode.TO_BE_SUBMITTED, // 待提交
    OrderStatusCode.TO_BE_DISPATCH, // 待派车
    OrderStatusCode.TO_BE_START, // 待提货
    // OrderStatusCode.TO_BE_SIGN, // 运输中-代签收
    // OrderStatusCode.PART_SIGN, // 运输中-部分签收
    OrderStatusCode.IN_TRANSIT,
    OrderStatusCode.ABNORMAL, // 异常
  ],
  [OrderProgressTab.FINISH]: [
    OrderStatusCode.BALANCE_CHECK, // 已签收
  ],
  [OrderProgressTab.CANCEL]: [
    OrderStatusCode.CANCEL,
  ]
};

// 用车类型
export const orderTypeMap = {
  0: '整车',
  1: '零担'
}

// 订单来源
export const OdrChannelMap = {
  SHIPPER: '货主下单',
  CARRIER: '承运商下单',
  IMPORT_ORDER: '导入订单',
  LIUHE_ORDER: '六合订单',
  DAIRY_ORDER: '乳业订单',
  EMAIL_ORDER: '邮件下单',
  TURN_TO_SEND_ORDER: '转派订单',
  UNKNOWN3: '未知',
  FRUIT_ORDER: '果盘运单',
  PROPAGATE: '主订单衍生',
  GUOPAN_MINI_APP: '小程序订单',
  FRESH_SCM: '商流订单',
  CUSTOMER_ORDER: '货主订单',
  CUSTOMER_IMPORT: '货主导入',
  CUSTOMER_OPEN_API: '货主OpenApi下单',
  RTS_OPEN_API: '乳业订单OpenApi下单',
  CUSTOMER_MINI_APP: '小程序货主订单',
  CUSTOMER_APP: '货主app下单'
}

// 用车需求
export const TransportType = {
  RUCKLOAD: 'TRUCKLOAD', // 整车 0
  BREAK_BULK: 'BREAK_BULK', // 零担 1
}
/**
 * @description: 运单配载状态
 */
export const WaybillStatusText = [
  {label:'转派',value:-2},
  {label:'取消接单',value:-1},
  {label:'未接单',value:0},
  {label:'待派车',value:1},
  {label:'已派车',value:2},
  {label:'运输中',value:3},
  {label:'已签收',value:4},
  {label:'待审核',value:5},
  {label:'完成',value:6},
  {label:'中转',value:7},
  {label:'中转撤销',value:8},
  {label:'提货',value:9},
  {label:'拆分',value:10},
  {label:'运输中',value:11},
  {label:'已取消',value:12}
]




/**
 * @description: 车辆类型、司机类型
 */
export const DriverTypeText = ['自有','外请','个体'] 


// 站点类型
export const StationTypes = {
  SHIPPING: 'SHIPPING', // 出发点
  RECEIVING: 'RECEIVING', // 送货点
  SHIPPING_RECEIVING: 'SHIPPING_RECEIVING', // 出发点+送货点
};

// 订单详情页 tab 类型
export const DetailTabs = {
  BASEINFO: 'base',
  CARINFO: 'car',
  WAREHOUSE: 'warehouse'
}

export const scrollPosition = {
  top: 'screenTop',
  id: 'popContainer',
  TAB: 'TAB',
  CURRENT: 'CURRENT',
}

// 订单类型select选择
export const OrderTypeList = [
  {
    value: '',
    label: '全部'
  },
  {
    value: 'STORE',
    label: '仓配入库'
  },
  {
    value: 'DELIVER',
    label: '仓配出库'
  },
  {
    value: 'DELIVER_TRANSPORT_STORE',
    label: '仓间调拨'
  },
  {
    value: 'DELIVER_STORE',
    label: '仓内调拨'
  },
]

// 是否运输
export const Transport = [
  {
    value: '',
    label: '全部'
  },
  {
    value: 1,
    label: '是'
  },
  {
    value: 0,
    label: '否'
  },
]

const scene = {
  'DELIVER_ONLY': 'DELIVER_ONLY',            // 出库
  'DELIVER_TRANSPORT': 'DELIVER_TRANSPORT',  // 出库运输
  'STORE_ONLY': 'STORE_ONLY',  // 入库运输
  'STORE_TRANSPORT': 'TRANSPORT_STORE',  // 入库运输
  'DELIVER_STORE': 'DELIVER_STORE',  // 仓内调拨
  'DELIVER_TRANSPORT_STORE': 'DELIVER_TRANSPORT_STORE',  // 仓间调拨
}
// 订单类型
export const SCENE = scene

export const SCENETYPE = {
  [scene.DELIVER_ONLY]: '仓配出库',
  [scene.DELIVER_TRANSPORT]: '仓配出库',
  [scene.STORE_ONLY]: '仓配入库',
  [scene.STORE_TRANSPORT]: '仓配入库',
  [scene.DELIVER_STORE]: '仓内调拨',
  [scene.DELIVER_TRANSPORT_STORE]: '仓间调拨'
}

// 仓配订单类型
export const warehouseOrderTypeALL = [
  {
    label: '待接单',
    value: 'SUBMITTED'
  },
  {
    label: '草稿',
    value: 'DRAFT'
  },
  {
    label: '待派车',
    value: 'DEAL'
  },
  {
    label: '待出库',
    value: 'TO_BE_DELIVER',
  },
  {
    label: '出库中',
    value: 'DELIVERING'
  },
  {
    label: '已出库',
    value: 'DELIVERED'
  },
  {
    label: '已派车',
    value: 'DISPATCHED'
  },
  {
    label: '运输中',
    value: 'STARTED'
  },
  {
    label: '已签收',
    value: 'SIGNED'
  },
  {
    label: '部分签收',
    value: 'PART_SIGNED'
  },
  {
    label: '待入库',
    value: 'TO_BE_STORE'
  },
  {
    label: '入库中',
    value: 'STORING'
  },
  {
    label: '已入库',
    value: 'STORED'
  },
  {
    label: '已完成',
    value: 'FINISHED'
  },
  {
    label: '已取消',
    value: 'CANCELED'
  },
  {
    label: '已拒收',
    value: 'REJECTED'
  },
  {
    label: '计费异常',
    value: 'EXP_CAL_STATUS'
  },
  {
    label: '信息错误',
    value: 'PRE_DRAFT'
  },
  {
    label: '授信余额评估中',
    value: 'FOR_CREDIT'
  },
  {
    label: '授信余额不足',
    value: 'FAIL_CREDIT'
  },
]
export const warehouseOrderTypeDOING = [
  {
    label: '待接单',
    value: 'SUBMITTED'
  },
  {
    label: '草稿',
    value: 'DRAFT'
  },
  {
    label: '待派车',
    value: 'DEAL'
  },
  {
    label: '待出库',
    value: 'TO_BE_DELIVER',
  },
  {
    label: '出库中',
    value: 'DELIVERING'
  },
  {
    label: '已出库',
    value: 'DELIVERED'
  },
  {
    label: '已派车',
    value: 'DISPATCHED'
  },
  {
    label: '运输中',
    value: 'STARTED'
  },
  {
    label: '已签收',
    value: 'SIGNED'
  },
  {
    label: '部分签收',
    value: 'PART_SIGNED'
  },
  {
    label: '已拒收',
    value: 'REJECTED'
  },
  {
    label: '待入库',
    value: 'TO_BE_STORE'
  },
  {
    label: '入库中',
    value: 'STORING'
  },
  {
    label: '已入库',
    value: 'STORED'
  },
  {
    label: '计费异常',
    value: 'EXP_CAL_STATUS'
  },
  {
    label: '信息错误',
    value: 'PRE_DRAFT'
  },
  {
    label: '授信余额评估中',
    value: 'FOR_CREDIT'
  },
  {
    label: '授信余额不足',
    value: 'FAIL_CREDIT'
  },
]
export const warehouseOrderTypeFINISH = [
  {
    label: '已完成',
    value: 'FINISHED'
  },
]
export const warehouseOrderTypeCANCEL = [
  {
    label: '已取消',
    value: 'CANCELED'
  },
]

const status = {
  draft: 'DRAFT',
  submitted: 'SUBMITTED',
  deal: 'DEAL',
  toBeDeliver: 'TO_BE_DELIVER',
  delivering: 'DELIVERING',
  delivered: 'DELIVERED',
  dispatched: 'DISPATCHED',
  started: 'STARTED',
  signed: 'SIGNED',
  toBeStore: 'TO_BE_STORE',
  storing: 'STORING',
  stored: 'STORED',
  finished: 'FINISHED',
  canceled: 'CANCELED',
  rejected: 'REJECTED',
  expStatus: 'EXP_CAL_STATUS',
  partSigned: 'PART_SIGNED',
  preDraft: 'PRE_DRAFT',
  forCredit: 'FOR_CREDIT',
  failCredit: 'FAIL_CREDIT',
};
// 订单状态枚举
export const STATUSTEXT = {
  [status.draft]: '草稿',
  [status.submitted]: '待接单',
  [status.deal]: '待派车',
  [status.delivering]: '出库中',
  [status.toBeDeliver]: '待出库',
  [status.delivered]: '已出库',
  [status.dispatched]: '已派车',
  [status.started]: '运输中',
  [status.signed]: '已签收',
  [status.toBeStore]: '待入库',
  [status.storing]: '入库中',
  [status.stored]: '已入库',
  [status.finished]: '已完成',
  [status.canceled]: '已取消',
  [status.rejected]: '已拒收',
  [status.expStatus]: '异常',
  [status.partSigned]: '部分签收',
  [status.preDraft]: '信息错误',
  [status.forCredit]: '授信余额评估中',
  [status.failCredit]: '授信余额不足',
};

export const ORDERSTATUS = status

export const SearchFiled= [
  {
  label:'订单号',
  name:'unifyOdrNo',
  type:'input',
  prop:{
    placeholder: '请输入订单号',
  }
},
{
  label:'外部订单号',
  name:'crmNumber',
  type:'input',
  prop:{
    placeholder: '请输入外部订单号',
    maxLength:100
  },
},
{
  label:'订单状态',
  name:'orderType',
  custom:true
},
{
  label:'订单类型',
  name:'scene',
  type:'select',
  prop:{
    placeholder: '请选择订单类型',
    options:OrderTypeList
  },
},
{
  label:'是否运输',
  name:'needTransport',
  type:'select',
  prop:{
    placeholder: '请选择是否运输',
    options:Transport
  },
},
{
  label:'下单日期',
  name:'createTime__BETWEEN',
  type:'date',
  prop:{
    showTime:{
      format: "HH:mm:ss",
      defaultValue:[moment().subtract(30, 'days').startOf('day'), moment().endOf('day')],
      },
    allowClear:true,
    format:"YYYY-MM-DD HH:mm:ss",
    placeholder: ['开始日期', '结束日期'],
    maxLength:100,
  },
},
{
  label:'下单人',
  name:'createUserName',
  type:'input',
  prop:{
    placeholder: '请选择下单人',
    maxLength:100
  },
},
{
  label:'站点',
  name:'stationInfo',
  type:'input',
  prop:{
    placeholder: '请输入站点名称或编码',
    maxLength:30
  },
},
{
  label:'服务商',
  name:'serviceProvider',
  custom:true
},
{
  label:'仓库',
  name:'warehouse',
  custom:true
  },
  {
    label: '下单货品名称',
    name: 'skuName',
    type:'input',
    prop:{
      placeholder: '请输入下单货品名称',
      maxLength:100
    },
  },
  {
    label:'运营项目',
    name:'projectIds',
    type: 'select',
    prop: {
      placeholder: '请选择运营项目',
      showSearch: true,
      options: [],
    }
  },
]
